import { render } from "./ClassCard.vue?vue&type=template&id=4aa04a84&scoped=true"
import script from "./ClassCard.vue?vue&type=script&lang=js"
export * from "./ClassCard.vue?vue&type=script&lang=js"

import "./ClassCard.vue?vue&type=style&index=0&id=4aa04a84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa04a84"]])

export default __exports__